import React from "react";

function ArrowDropDown() {
  return (
    // <div className="text-dark-primary">
    //   <svg
    //     width="10"
    //     height="6"
    //     viewBox="0 0 10 6"
    //     fill="none"
    //     xmlns="http://www.w3.org/2000/svg"
    //   >
    //     <path d="M5 5.5L0 0.5H10L5 5.5Z" fill="currentColor" />
    //   </svg>
    // </div>
    // `text-dark-primary dark:bg-blue-700 ${className} `
    <div className="text-dark-primary dark:text-dark-text">
      <svg
        width="10"
        height="6"
        viewBox="0 0 10 6"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M5 5.5L0 0.5H10L5 5.5Z" fill="currentColor" />
      </svg>
    </div>
  );
}

export default ArrowDropDown;
